__turbopack_context__.v({
  "footer": "footer-module-scss-module__BKh3Zq__footer",
  "footerBottom": "footer-module-scss-module__BKh3Zq__footerBottom",
  "footerBottomInner": "footer-module-scss-module__BKh3Zq__footerBottomInner",
  "footerColumn": "footer-module-scss-module__BKh3Zq__footerColumn",
  "footerList": "footer-module-scss-module__BKh3Zq__footerList",
  "footerListAccount": "footer-module-scss-module__BKh3Zq__footerListAccount",
  "footerListFeatured": "footer-module-scss-module__BKh3Zq__footerListFeatured",
  "footerTitle": "footer-module-scss-module__BKh3Zq__footerTitle",
  "footerTop": "footer-module-scss-module__BKh3Zq__footerTop",
});
